import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import CopyToClipboardButton from 'renderer/shared/components/CopyToClipboardButton';
import { Subscription } from '../schemas/users.schemas';

interface SubscriptionKeyDetailsProps {
  open: boolean;
  handleClose: () => void;
  subscription?: Subscription;
}

const SubscriptionKeyDetails: React.FC<SubscriptionKeyDetailsProps> = ({
  open,
  handleClose,
  subscription,
}) => {
  const activationsAvailable = subscription?.count ?? 0;
  const activationsUsed = subscription?.activations?.length ?? 0;
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {subscription?.serial}{' '}
        <CopyToClipboardButton textToCopy={subscription?.serial ?? ''} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have used {activationsUsed} of {activationsAvailable} available
          activations on this subscription.
        </DialogContentText>
        {subscription &&
        subscription.activations &&
        subscription.activations.length ? (
          <List>
            {subscription.activations.map((activation) => (
              <ListItem>
                <ListItemText>MAC Address: {activation.mac}</ListItemText>
              </ListItem>
            ))}
          </List>
        ) : null}
        <DialogContentText>Users</DialogContentText>
        <List>
          {subscription && subscription.group && subscription.group.length ? (
            subscription.group.map((group) => (
              <ListItem>
                <ListItemText>{group.email}</ListItemText>
              </ListItem>
            ))
          ) : (
            <ListItem>No Users</ListItem>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionKeyDetails;
